import axios from 'axios';
 
const BASE_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BASE_URL}/api`;
 
const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 second timeout
});
 
// Request interceptor to add JWT token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
 
    // Also add user_id header for legacy endpoints
    const user = localStorage.getItem('currentUser');
    if (user) {
      try {
        const userData = JSON.parse(user);
        config.headers['user_id'] = userData.id;
      } catch (e) {
        // Ignore parse errors
      }
    }
 
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
 
// Response interceptor for handling errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle network errors
    if (!error.response) {
      error.userMessage = 'Network error. Please check your connection and try again.';
      return Promise.reject(error);
    }
 
    const status = error.response.status;
 
    switch (status) {
      case 401:
        // Clear auth data and redirect to login
        localStorage.removeItem('token');
        localStorage.removeItem('currentUser');
        window.location.href = '/login';
        break;
      case 403:
        error.userMessage = 'You do not have permission to perform this action.';
        break;
      case 404:
        error.userMessage = 'The requested resource was not found.';
        break;
      case 422:
        // Validation error
        error.userMessage = error.response.data?.detail || 'Invalid data submitted. Please check your inputs.';
        break;
      case 429:
        error.userMessage = 'Too many requests. Please wait a moment and try again.';
        break;
      case 500:
        error.userMessage = 'Server error. Please try again or contact your administrator.';
        break;
      default:
        error.userMessage = error.response.data?.detail || 'An unexpected error occurred.';
    }
 
    return Promise.reject(error);
  }
);
 
export default apiClient;
export { API };
